import { AdminResourceEditor } from "./AdminResourceEditor";

const FIELDS = [
  { name: "title", label: "Title" },
  { name: "description", label: "Description", type: "textarea" },
  { name: "thumbnail", label: "Thumbnail Image", type: "image" },
  { name: "video_url", label: "Video File (uploaded directly)", type: "video", required: false },
  { name: "youtube_id", label: "OR YouTube Video ID (used if no video file uploaded)", required: false },
  { name: "duration", label: "Duration (e.g. 4:15)" },
];

const DEFAULTS = { title: "", description: "", thumbnail: "", video_url: "", youtube_id: "", duration: "" };

export default function AdminVlog() {
  return (
    <AdminResourceEditor
      resourceLabel="Vlog Video"
      apiPath="/admin/vlog"
      fields={FIELDS}
      defaultValues={DEFAULTS}
      renderItem={(item) => (
        <>
          <p className="text-cream truncate">{item.title}</p>
          <p className="text-smoke text-xs mt-1">{item.duration}</p>
        </>
      )}
    />
  );
}
